import React, { useState, useRef, useEffect } from "react";
import "./breadcrum.scss";
import SortIcons from "constants/Homepage/ysafe/iconFunctions/sortIcons";

const TRUNCATE_THRESHOLD = 4;
const VISIBLE_TAIL = 2;


const Breadcrumb = ({ currentPath, setCurrentPath, dupCurrentPath, activeTab, allFiles = null, setdupCurrentPath }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const path = activeTab + 1 !== 2 ? currentPath : dupCurrentPath;
  const pathLength = path.length;
  const shouldTruncate = pathLength > TRUNCATE_THRESHOLD;
  const tailStart = shouldTruncate ? pathLength - VISIBLE_TAIL : 0;

  const handleNavigation = (index) => {
    let newPath = currentPath.slice(0, index + 1);
    const newDupPath = dupCurrentPath.slice(0, index + 1);
    if (activeTab + 1 === 2) {
      newPath = currentPath.slice(0, index + 2);
    }
    setCurrentPath(newPath);
    setdupCurrentPath(newDupPath);
    setDropdownOpen(false);
  };

  const handleRootClick = () => {
    if (activeTab + 1 === 2) {
      setCurrentPath(["shared"]);
    } else {
      setCurrentPath([]);
    }
    setdupCurrentPath([]);
    setDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const pathForTitle = pathLength > 0
    ? [(activeTab + 1 === 2 ? "Shared With Me" : "All Files"), ...path].join(" > ")
    : (activeTab + 1 === 2 ? "Shared With Me" : "All Files");

  const renderSegment = (folder, index, isCurrent) => (
    <span key={index}>
      <span className="arrowBox">
        <SortIcons type="arrow" color="var(--text-grey-strong)" />
      </span>
      <span
        style={{ cursor: "pointer" }}
        onClick={() => handleNavigation(index)}
        className={isCurrent ? "current" : "previous"}
        title={folder}
      >
        {folder}
      </span>
    </span>
  );

  return (
    <nav className="breadcrumContainer" ref={dropdownRef} title={pathForTitle} aria-label={`Breadcrumb: ${pathForTitle}`}>
      {(allFiles ?? pathLength > 0) && (
        <span style={{ cursor: "pointer" }} onClick={handleRootClick} className="allFiles">
          {activeTab + 1 === 2 ? "Shared With Me" : "All Files"}
        </span>
      )}

      {!shouldTruncate &&
        path.map((folder, index) =>
          renderSegment(folder, index, index === pathLength - 1)
        )}

      {shouldTruncate && (
        <>
          <span className="arrowBox">
            <SortIcons type="arrow" color="var(--text-grey-strong)" />
          </span>
          <span className="breadcrumEllipsisWrap">
            <span
              className="breadcrumEllipsis"
              onClick={() => setDropdownOpen((o) => !o)}
              title={path.slice(0, tailStart).join(" > ")}
            >
              ...
            </span>
            {dropdownOpen && (
              <div className="breadcrumDropdown">
                {path.slice(0, tailStart).map((folder, i) => (
                  <button
                    key={i}
                    type="button"
                    className="breadcrumDropdownItem"
                    onClick={() => handleNavigation(i)}
                  >
                    {folder}
                  </button>
                ))}
              </div>
            )}
          </span>
          {path.slice(tailStart).map((folder, i) => {
            const index = tailStart + i;
            return renderSegment(folder, index, index === pathLength - 1);
          })}
        </>
      )}
    </nav>
  );
};

export default Breadcrumb;
